/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logo-half-top': {
    width: 187,
    height: 59,
    viewBox: '0 0 187 59',
    data: '<path pid="0" d="M88.2 1.7l-6.6 17.1-14.8 5.3L62.5 35 0 58.8l12.1-31L88.2 1.7zm54.6 0l-4.2 10.5-14.1 5.2-4.7 12.1-61.4 29.3 12.2-30.7 72.2-26.4zM186.6 0l-69.8 50.5 11.6-29.2L186.6 0z" _fill="#000" fill-rule="nonzero"/>'
  }
})
